import { useLocation } from '@faceup/router'
import { PageContentSkeleton, useFancyAppLoader } from '@faceup/ui'
import { type ReactNode, Suspense, useEffect } from 'react'

type PageSuspenseProps = {
  children: ReactNode
}

export const PageSuspense = ({ children }: PageSuspenseProps) => {
  const location = useLocation()
  /**
   * Suspense should be triggered only on the first level of pages.
   */
  const getFirstPartOfUrl: () => string = () => {
    return location.pathname.split('/')[1] || ''
  }

  return (
    <Suspense fallback={<FancyPageContentSkeleton />} key={getFirstPartOfUrl()}>
      {children}
    </Suspense>
  )
}

const FancyPageContentSkeleton = () => {
  const { show, hide } = useFancyAppLoader()
  // biome-ignore lint/correctness/useExhaustiveDependencies: Only run on mount and unmount for loader lifecycle
  useEffect(() => {
    show()
    return () => {
      hide()
    }
  }, [])
  return <PageContentSkeleton />
}
